import Api from 'App/api'

export const getUsage = Api.get({
  controller: 'utilities',
  action: 'getUsage',
})

export const getInvoices = Api.get({
  controller: 'utility_invoice',
  action: 'getInvoices',
})

export const getInvoice = Api.get({
  controller: 'utility_invoice',
  action: 'getInvoice',
})
